import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { appInsights } from './api/telemetry/appInsights';

// When MSAL's ssoSilent opens a hidden iframe, the iframe loads this same app
// at window.location.origin with the auth code in the hash. We detect this
// immediately — before React mounts — initialize MSAL, call
// handleRedirectPromise() so it broadcasts the token back to the parent via
// BroadcastChannel, then stop. Mounting the full React tree here would be too
// slow and cause the parent's iframeBridgeTimeout to fire first.
const isInsideMsalIframe =
  window.parent !== window &&
  (window.location.hash.includes('code=') || window.location.hash.includes('error='));

if (isInsideMsalIframe) {
  import('./api/auth/msalConfig').then(({ msalInternal }) => {
    msalInternal.initialize().then(() => {
      msalInternal.handleRedirectPromise().catch(() => {});
    });
  });
} else {
  if (process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING) {
    appInsights.loadAppInsights();
    reportWebVitals(({ name, value }) => {
      appInsights.trackMetric({ name, average: value });
    });
  }

  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
